import { categoryConstants as constants } from '../constants';
import { authHeader, config, responseHandler } from '../helpers';

export const categoryActions = {
    requestAll,
    requestCategories,
    requestParents,
    requestThemePackages,
    addThemePackage,
    duplicateThemePackage,
    addOrUpdateCategoryTheme,
    editThemePackage,
    removeCategoryTheme,
    removeThemePackage,
    addOrganizationToThemePackage,
    removeOrganizationFromThemePackage,
    testModels,
    requestContractTypes
};

function requestAll() {
    return async (dispatch) => {

        dispatch({ type: constants.GET_CATEGORIES_REQUEST });
        dispatch({ type: constants.GET_THEME_PACKAGES_REQUEST });

        const url = config.categoryUrl + '/GetAll';
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };
        const result = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.GET_CATEGORIES_SUCCESS, categories: result.categories });
        dispatch({ type: constants.GET_THEME_PACKAGES_SUCCESS, themePackages: result.themePackages });
    };
}

function requestCategories() {
    return async (dispatch) => {

        dispatch({ type: constants.GET_CATEGORIES_REQUEST });

        const url = config.categoryUrl + '/GetFromAIService';
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };
        const categories = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.GET_CATEGORIES_SUCCESS, categories });
    };
}

function requestParents() {
    return async (dispatch) => {

        dispatch({ type: constants.GET_PARENT_CATEGORIES_REQUEST });

        const url = config.categoryUrl + '/GetParents';
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };
        const parents = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.GET_PARENT_CATEGORIES_SUCCESS, parents });
    };
}

function addOrUpdateCategoryTheme(id, categoryTheme) {
    return async (dispatch) => {

        dispatch({ type: constants.ADD_OR_UPDATE_CATEGORY_THEME_REQUEST });

        if (id === null || id === "" || categoryTheme === null) {
            dispatch({ type: constants.ADD_OR_UPDATE_CATEGORY_THEME_FAILURE });
            return;
        }

        var headers = authHeader();
        headers['Content-Type'] = 'application/json';

        const url = config.categoryUrl + `/AddOrUpdateTheme?id=${id}`;
        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(categoryTheme)
        };
        const editedCategory = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.ADD_OR_UPDATE_CATEGORY_THEME_SUCCESS, id, categoryTheme: editedCategory });
    };
}

function removeCategoryTheme(id, categoryTheme) {
    return async (dispatch) => {

        dispatch({ type: constants.REMOVE_THEME_REQUEST });

        if (id === null || id === "" || categoryTheme === null) {
            dispatch({ type: constants.REMOVE_THEME_FAILURE });
            return;
        }

        var headers = authHeader();
        headers['Content-Type'] = 'application/json';

        const url = config.categoryUrl + `/DeleteTheme?id=${id}&categoryThemeCode=${categoryTheme.code}`;
        const requestOptions = {
            method: 'GET',
            headers: headers
        };
        await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.REMOVE_THEME_SUCCESS, id, categoryTheme });
    };
}

///// THEME PACKAGES /////

function requestThemePackages() {
    return async (dispatch) => {

        dispatch({ type: constants.GET_THEME_PACKAGES_REQUEST });

        const url = config.categoryUrl + '/GetThemePackages';
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };
        const themePackages = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.GET_THEME_PACKAGES_SUCCESS, themePackages });
    };
}

function addThemePackage(name, contractType) {
    return async (dispatch) => {

        dispatch({ type: constants.ADD_THEME_PACKAGE_REQUEST });

        const url = config.categoryUrl + `/CreateThemePackage?name=${name}&contractType=${contractType}`;
        const requestOptions = {
            method: 'POST',
            headers: authHeader()
        };
        const themePackage = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.ADD_THEME_PACKAGE_SUCCESS, themePackage });
    };
}

function duplicateThemePackage(id) {
    return async (dispatch) => {

        dispatch({ type: constants.ADD_THEME_PACKAGE_REQUEST });

        const url = config.categoryUrl + `/DuplicateThemePackage?id=${id}`;
        const requestOptions = {
            method: 'POST',
            headers: authHeader()
        };
        const themePackage = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.ADD_THEME_PACKAGE_SUCCESS, themePackage });
    };
}

function editThemePackage(themePackage) {
    return async (dispatch) => {

        dispatch({ type: constants.EDIT_THEME_PACKAGE_REQUEST });

        var headers = authHeader();
        headers['Content-Type'] = 'application/json';

        const url = config.categoryUrl + '/EditThemePackage';
        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(themePackage)
        };
        const editedThemePackage = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.EDIT_THEME_PACKAGE_SUCCESS, themePackage: editedThemePackage });
    };
}

function addOrganizationToThemePackage(packageId, organizationId) {
    return async (dispatch) => {

        dispatch({ type: constants.ADD_ORGANIZATION_TO_THEME_PACKAGE_REQUEST });

        var headers = authHeader();
        headers['Content-Type'] = 'application/json';

        const url = config.categoryUrl + `/AddOrganizationToTheme?id=${packageId}&organizationId=${organizationId}`;
        const requestOptions = {
            method: 'POST',
            headers: headers
        };
        const editedThemePackage = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.ADD_ORGANIZATION_TO_THEME_PACKAGE_SUCCESS, themePackage: editedThemePackage });
    };
}

function removeOrganizationFromThemePackage(packageId, organizationId) {
    return async (dispatch) => {

        dispatch({ type: constants.REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_REQUEST });

        var headers = authHeader();
        headers['Content-Type'] = 'application/json';

        const url = config.categoryUrl + `/DeleteOrganizationFromTheme?id=${packageId}&organizationId=${organizationId}`;
        const requestOptions = {
            method: 'POST',
            headers: headers
        };
        const editedThemePackage = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.REMOVE_ORGANIZATION_FROM_THEME_PACKAGE_SUCCESS, themePackage: editedThemePackage });
    };
}

function removeThemePackage(id) {
    return async (dispatch) => {

        dispatch({ type: constants.REMOVE_THEME_PACKAGE_REQUEST });

        if (id === null || id === "") {
            dispatch({ type: constants.REMOVE_THEME_PACKAGE_FAILURE });
            return;
        }

        var headers = authHeader();
        headers['Content-Type'] = 'application/json';

        const url = config.categoryUrl + `/DeleteThemePackage?id=${id}`;
        const requestOptions = {
            method: 'POST',
            headers: headers
        };
        await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        dispatch({ type: constants.REMOVE_THEME_PACKAGE_SUCCESS, id });
    };
}

function testModels(text) {
    return async (dispatch) => {

        dispatch({ type: constants.TEST_MODELS_REQUEST });

        const url = config.categoryUrl + `/TestModels?text=${text}`;
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };

        const response = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        if (response.status === 500 || response.status === 403) {
            dispatch({ type: constants.RECEIVE_ERROR });
            return;
        }

        dispatch({ type: constants.TEST_MODELS_SUCCESS, modelsResults: response });
    };
}

///// CONTRACT TYPES /////
function requestContractTypes() {
    return async (dispatch) => {

        dispatch({ type: constants.GET_CONTRACT_TYPES_REQUEST });

        const url = config.categoryUrl + `/GetContractTypesForUser`;
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };

        const response = await fetch(url, requestOptions)
            .then(responseHandler.handleResponse, responseHandler.handleError);

        if (response.status === 500 || response.status === 403) {
            dispatch({ type: constants.RECEIVE_ERROR });
            return;
        }

        dispatch({ type: constants.GET_CONTRACT_TYPES_SUCCESS, contractTypes: response });
    };
}


// WEBPACK FOOTER //
// ./src/actions/category.actions.js